import MOD_LOGO from '../static/logo/MOD-LOGO-WHITE.png';
import PRF_LOGO from '../static/logo/PRF_LOGO_BG_WHITE.png';
import PDF_LOGO from '../static/logo/PDF_FLAG.png';
import { logger } from '@sentry/utils';
import { Footer } from '../components/Footer';
import { MemberCardInfo } from '../components/Member/MemberCardInfo';
import { MemberContinuousInfo } from '../components/Member/MemberContinuousInfo';
import { MemberTransactionsInfo } from '../components/Member/MemberTransactionsInfo';
import { getRecordByUuidTemplate, openInNewTab } from '../services/Api';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LoadingMember } from '../components/Member/LoadingMember';
import { MemberNotFound } from '../components/Member/MemberNotFound';
import { SupportCalendar } from '../components/Member/SupportCalendar';
import { Box, Stack, Grid, CardMedia, Typography } from '@mui/material';

const HeaderLogo = styled('img')({
  cursor: 'pointer',
  maxHeight: '4rem',
  objectFit: 'contain',
  width: '100px',
  height: 'auto'
});

export function MemberVerifyPage() {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const testing = queryParams.get('tt');
  const memberid = queryParams.get('mbid');
  const uuid = queryParams.get('uuid');
  const prjTp = queryParams.get('prjTp');
  const [isLoading, setIsLoading] = useState(false);
  const [record, setRecord] = useState([]);
  const [validQuery, setValidQuery] = useState(false);
  const [hasRec,setHasRec] = useState(false);

  useEffect(() => {
    if (uuid && prjTp) {
      getData();
    } else {
      setValidQuery(false);
      setIsLoading(false);
    }
  }, [uuid, prjTp]);

  useEffect(() => {
    setHasRec(true);
  },[record]);

  const sampleData = () => {
    let data =[
      {
        "member_id": 1234, 
        "member_name": "Tester Chris", 
        "transactions": [
          {
            "id": 2840,
            "fundraiser_id": 3, 
            "contribution_date": "2021-12-15",
            "valid_thru": "2021-12-31",
            "amout": 333333.3333333333,
            "currency_iso": "WON",
            "ofp_usd_est": 238.09666666666666
          },
          {
            "id": 2841,
            "fundraiser_id": 3, 
            "contribution_date": "2021-12-15",
            "valid_thru": "2022-01-31",
            "amout": 333333.3333333333,
            "currency_iso": "WON",
            "ofp_usd_est": 238.09666666666666
          },
          {
            "id": 2842,
            "fundraiser_id": 2, 
            "contribution_date": "2022-04-23",
            "valid_thru": "2022-04-30",
            "amount": 100.0,
            "currency_iso": "SGD",
            "ofp_usd_est": 74.63
          },
          {
            "id": 2843,
            "fundraiser_id": 8888, 
            "contribution_date": "2023-01-28",
            "valid_thru": "2023-01-31",
            "amout": 20,
            "currency_iso": "USD",
            "ofp_usd_est": 20
          },
          {
            "id": 2844,
            "fundraiser_id": 8888, 
            "contribution_date": "2023-01-28",
            "valid_thru": "2023-02-28",
            "amout": 20,
            "currency_iso": "USD",
            "ofp_usd_est": 20
          }
        ]
      }
    ];
    return data;
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      // Local testing
      if (testing==='1') {
        let thisRecord = sampleData();
        setRecord(thisRecord);
      }
      else {
        let response = await getRecordByUuidTemplate(uuid, prjTp, memberid);
        switch (response?.data?.statusCode) {
          case 200:
            let data = response.data.body;
            data.memberid_flag= (memberid != null);
            if (data?.member_id) {
              setRecord(data);
              logger.log('[MemberVerify] >>>', record);
            }
            setHasRec(true);
            break;
  
          default:
            setHasRec(false);
        }
      }
    } catch (err) {
      logger.log('[MemberVerify]Error at getRecordByUuidTemplate:', err);
    } finally {
      setIsLoading(false);
      setValidQuery(true);
      logger.log('Test: Record Found', uuid, prjTp, validQuery);
    }
  };

  return (
<Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#E6E6E6',
  }}
>
  {/* New full-width header container with gradient */}
  <Box
    sx={{
      width: '100%',
      background: 'linear-gradient(to bottom, #530D0D, #B91C1C)',
      display: 'flex',
      justifyContent: 'center',
      py: 3,
    }}
  >
    <Stack
      spacing={2}
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        maxWidth: '1230px'
      }}
    >
      <Stack
        direction='row'
        spacing={0}
        sx={{ 
          width: '100%', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
        }}
      >
         <HeaderLogo
          src={MOD_LOGO}
          alt='MOD'
          onClick={() => openInNewTab('https://www.facebook.com/modNUG')}
        />
        <HeaderLogo
          src={PRF_LOGO}
          alt='PRF'
          onClick={() => openInNewTab('https://www.facebook.com/prf4pdf')}
        />
        <HeaderLogo
          src={PDF_LOGO}
          alt='PDF'
          sx={{ marginLeft: '10px' }}
          onClick={() => openInNewTab('https://www.facebook.com/prf4pdf')}
        />
      </Stack>
      {record?.transactions && record.memberid_flag && (
        <Typography 
          sx={{
            color: '#fff',
            typography: { 
              md: 'h4',
              sm: 'h5' 
            },
            fontWeight: 'bold'
          }}>
          ပြည်သူ့တော်လှန်ရေးထောက်ပို့တပ် - PRF
        </Typography>
      )}
    </Stack>
  </Box>

  {/* Rest of your content */}
  <Stack
    spacing={2}
    paddingTop={2}
    sx={{ 
      // width: { 
      //   sm: record?.transactions ? '70%' : '40%',
      //   xs: '95%' 
      // },
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      width: '100%',
      maxWidth: '1200px',
      padding: '1rem'
    }}
  > 
    {isLoading ? (
      <LoadingMember />
    ) : (
      hasRec ?
        (
        <Box sx={{ width: '100%' }}>
          <Grid container spacing={{ md: 3, sm: 2, xs: 2 }}>
            <Grid size={{ md: 6, sm: 12, xs: 12 }} key={`index1`}>
              <MemberCardInfo data={record} />
            </Grid>
            <Grid size={{ md: 6, sm: 12, xs: 12 }} key={`index2`}>
              <MemberContinuousInfo data={record} />
            </Grid>            
          </Grid>
        </Box>    
        )
        :
        (<MemberNotFound />)
    )}        
    
    {record?.transactions && record.memberid_flag && 
      <Box sx={{ width: '100%', backgroundColor: '#fff', borderRadius: '1.5rem' }}>
        <Stack sx={{ borderRadius: '1.5rem'}} spacing={1}>
          <SupportCalendar data={record} />
          <hr/>
          <MemberTransactionsInfo data={record} />
        </Stack>
      </Box>
    }
    <Footer />
  </Stack>
</Box>
  );
}
